import { useOffline } from '../../context/OfflineContext';
import { WifiOff, RefreshCw, CloudOff, Check } from 'lucide-react';

const OfflineIndicator = () => {
  const { isOnline, isSyncing, pendingCount, syncOfflineQueue } = useOffline();

  // Don't show anything if online and no pending actions
  if (isOnline && pendingCount === 0) {
    return null;
  }

  return (
    <div className={`fixed bottom-20 lg:bottom-4 left-4 right-4 lg:left-auto lg:right-4 lg:w-auto z-50 animate-fade-in`}>
      <div className={`flex items-center gap-3 px-4 py-3 rounded-lg shadow-lg border ${
        isOnline 
          ? 'bg-amber-50 border-amber-200 text-amber-800' 
          : 'bg-gray-100 border-gray-300 text-gray-700'
      }`}>
        {!isOnline ? (
          <>
            <WifiOff className="w-5 h-5 shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="font-medium text-sm">You're offline</p>
              <p className="text-xs opacity-75">Changes saved locally</p>
            </div>
            <CloudOff className="w-4 h-4 opacity-50" />
          </>
        ) : isSyncing ? (
          <>
            <RefreshCw className="w-5 h-5 shrink-0 animate-spin" />
            <div className="flex-1 min-w-0">
              <p className="font-medium text-sm">Syncing...</p>
              <p className="text-xs opacity-75">{pendingCount} pending</p>
            </div>
          </>
        ) : pendingCount > 0 ? (
          <>
            <CloudOff className="w-5 h-5 shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="font-medium text-sm">{pendingCount} pending sync</p>
              <p className="text-xs opacity-75">Tap to sync now</p>
            </div>
            <button
              onClick={syncOfflineQueue}
              className="px-3 py-1 text-xs font-medium bg-amber-600 text-white rounded hover:bg-amber-700 transition-colors"
            >
              Sync
            </button>
          </>
        ) : (
          <>
            <Check className="w-5 h-5 shrink-0 text-green-600" />
            <div className="flex-1 min-w-0">
              <p className="font-medium text-sm text-green-700">All synced!</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default OfflineIndicator;
